import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { AlocacoesQuery, AlocacoesQueryVariables } from './__generated__/AlocacoesQuery';

const ALOCACOES_QUERY = gql`
  query AlocacoesQuery($id_oferta: Int!, $id_turma: Int!, $dat_inicio: String!, $dat_fim: String!) {
    alocacoes_professores(
      where: {
        id_oferta: $id_oferta
        id_turma: $id_turma
        dat_inicio: $dat_inicio
        dat_fim: $dat_fim
      }
    ) {
      id_alocacao
      id_oferta
      id_turma
      dat_alocacao
      ind_status
      planejamento
      disciplina {
        id_disciplina
        dsc_sigla
        num_carga_horaria
      }
      professor {
        id_professor
        dsc_nome_professor
      }
    }
    feriados(where: { dat_inicio: $dat_inicio, dat_fim: $dat_fim }) {
      id_feriado
      dsc_feriado
      dat_feriado
    }
  }
`;

const useAlocacoesQuery = (variables: AlocacoesQueryVariables) => {
  return useQuery<AlocacoesQuery, AlocacoesQueryVariables>(ALOCACOES_QUERY, {
    variables,
    fetchPolicy: 'network-only',
  });
};

const useAlocacoesLazyQuery = () => {
  return useLazyQuery<AlocacoesQuery, AlocacoesQueryVariables>(ALOCACOES_QUERY, {
    fetchPolicy: 'network-only',
  });
};

export { useAlocacoesQuery, useAlocacoesLazyQuery };
